/**
 * SPDX-License-Identifier: MPL-2.0
 * Copyright 2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2022 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 * Copyright 2023-2024 (c) Marc Fischer, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2024 (c) Daniel Littfinski, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2026 (c) Nico Brandt, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import './NavMenu.css';
import { BsBoxArrowInRight, BsBoxArrowLeft } from 'react-icons/bs';
import { AllowedRoles, AuthRequired, useAuth } from 'Contexts/Auth';
import { useNavigate } from 'react-router-dom';

export const NavMenu = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  return (
    <header>
      <Navbar bg="light" expand="lg">
        <Navbar.Brand href="/">MsgToDb</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <AuthRequired>
            <Nav className="mr-auto">
              <Nav.Link href="MachineList">MachineList</Nav.Link>
            </Nav>
            <Nav className="mr-auto">
              <Nav.Link href="Softwares">SoftwareList</Nav.Link>
            </Nav>
            <AllowedRoles roles={['SuperAdmin']}>
              <Nav className="mr-auto">
                <Nav.Link href="Fairs">FairList</Nav.Link>
              </Nav>
            </AllowedRoles>
            <AllowedRoles roles={['SuperAdmin', 'Admin']}>
              <Nav className="mr-auto">
                <Nav.Link href="Users">UserList</Nav.Link>
              </Nav>
            </AllowedRoles>
            <Nav className="mr-auto">
              <Nav.Link href="CompanyData">CompanyData</Nav.Link>
            </Nav>
          </AuthRequired>
          <Nav className="mr-auto">
            {auth.authed != undefined && auth.authed == true ? (
              <>
                <Nav className="mr-auto">
                  <Nav.Link href="Me" className="">
                    About Me
                  </Nav.Link>
                </Nav>
                <Nav.Link
                  onClick={() => {
                    auth.logout();
                    navigate(window.location);
                  }}
                >
                  <BsBoxArrowLeft size="1.5em" />
                </Nav.Link>
              </>
            ) : (
              <>
                <Nav.Link href="Login">
                  <BsBoxArrowInRight size="1.5em" />
                </Nav.Link>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </header>
  );
};
